(() => {
  let timeoutId;
  
  document.addEventListener('cart:items-changed', (event) => {
    updateCartCount(event.detail.itemCount);
    
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      refreshCartDrawer();
    }, 1000);
  });

  document.addEventListener('cart:refresh-completed', () => {
    fetchAndUpdateCartCount();
  });
})();

(() => {
  if (window.abraFeaturedInitialized) return;
  window.abraFeaturedInitialized = true;
  
  const init = () => {
    const featuredProduct = document.querySelector('.featured-product');
    const productInfo = document.querySelector('product-info');
    
    if (!featuredProduct || !productInfo) return;
    
    let productHandle = productInfo.getAttribute('data-la-dn-product-handle');
    if (!productHandle) {
      const productUrl = productInfo.getAttribute('data-product-url');
      if (productUrl) {
        productHandle = productUrl.replace('/products/', '');
      }
    }
    
    const variantScript = productInfo.querySelector('script[data-selected-variant]');
    let variantId = null;
    
    if (variantScript) {
      try {
        const variantData = JSON.parse(variantScript.textContent);
        variantId = variantData.id;
      } catch (e) {
        return;
      }
    }
    
    if (!productHandle || !variantId) return;
    
    featuredProduct.setAttribute('data-product-handle', productHandle);
    featuredProduct.setAttribute('data-variant-id', variantId);
    productInfo.setAttribute('data-product-handle', productHandle);
    productInfo.setAttribute('data-variant-id', variantId);
    
    const priceElement = productInfo.querySelector('[data-la-dn-price] .price');
    if (priceElement) {
      priceElement.setAttribute('data-product-handle', productHandle);
      priceElement.setAttribute('data-variant-id', variantId);
    }
    
    if (window.Abra && window.Abra.render) {
      setTimeout(() => window.Abra.render(), 500);
    }
    
    const variantPicker = document.querySelector('variant-picker');
    if (variantPicker && !productInfo.hasAttribute('data-abra-observer')) {
      productInfo.setAttribute('data-abra-observer', 'true');
      
      const observer = new MutationObserver(() => {
        const updatedScript = productInfo.querySelector('script[data-selected-variant]');
        if (updatedScript) {
          try {
            const updatedVariant = JSON.parse(updatedScript.textContent);
            const newVariantId = updatedVariant.id;

            if (newVariantId.toString() === productInfo.getAttribute('data-variant-id')) return;

            const livePriceElement = productInfo.querySelector('[data-la-dn-price] .price');
            featuredProduct.setAttribute('data-variant-id', newVariantId);
            productInfo.setAttribute('data-variant-id', newVariantId);
            if (livePriceElement) {
              livePriceElement.setAttribute('data-product-handle', productHandle);
              livePriceElement.setAttribute('data-variant-id', newVariantId);
            }
            
            if (window.Abra && window.Abra.render) {
              window.Abra.render();
            }
          } catch (e) {}
        }
      });
      
      observer.observe(productInfo, { childList: true, subtree: true, characterData: true });
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Keeps Sezzle widget only inside the featured-product price wrapper and syncs its amount when Abra re-renders
(() => {
  if (!window.location.pathname.includes('/products')) return;

  const priceWrapper =
    document.querySelector('.featured-product .product__info .product__price.grid.gap-3') ||
    document.querySelector('.featured-product .product__info .product__price') ||
    document.querySelector('.featured-product .product__info');
  if (!priceWrapper) return;

  const SEZZLE = '.sezzle-shopify-info-button';
  const INSTALLMENTS = 5;
  let lastPrice = null, debounceTimer;

  const init = () => {
    document.head.insertAdjacentHTML('beforeend', `<style>
      ${SEZZLE} ~ ${SEZZLE}{display:none!important}
      .horizontal-products ${SEZZLE},
      .card ${SEZZLE},
      .quick-view ${SEZZLE},
      .search__results ${SEZZLE},
      .product-sticky-form ${SEZZLE}{display:none!important}
    </style>`);

    const updateAmount = () => {
      const price = parseFloat(priceWrapper.querySelector('.price .price__regular')?.textContent.replace(/[^0-9.]/g, ''));
      if (isNaN(price) || price <= 0 || price === lastPrice) return;
      lastPrice = price;
      const installment = '$' + (price / INSTALLMENTS).toFixed(2);
      document.querySelectorAll('.sezzle-payment-amount').forEach(el => el.textContent = installment);
    };

    new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updateAmount, 300);
    }).observe(priceWrapper, { childList: true, subtree: true });

    setTimeout(updateAmount, 1000);
  };

  if (priceWrapper.querySelector(SEZZLE)) {
    init();
  } else {
    const observer = new MutationObserver(() => {
      if (!priceWrapper.querySelector(SEZZLE)) return;
      observer.disconnect();
      init();
    });
    observer.observe(priceWrapper, { childList: true, subtree: true });
  }
})();
